import {
  DesignationListResponse,
  ICreateDesignationPayload,
  ICreateDesignationResponse,
  IEditDesignationResponse,
} from "../../../features/designation/types";
import ApiService from "../../ApiService";

enum DesignationEndpoints {
  LIST = "/designation-list",
  EDIT = "/designation",
  SAVE = "/designation/save",
}

class DesignationService extends ApiService {
  async getDesignations(): Promise<DesignationListResponse> {
    return this.get(DesignationEndpoints.LIST);
  }

  async getEditDesignation(id: number): Promise<IEditDesignationResponse> {
    return this.get(`${DesignationEndpoints.EDIT}/${id}`);
  }

  async saveDesignation(
    payload: ICreateDesignationPayload
  ): Promise<ICreateDesignationResponse> {
    return this.post(DesignationEndpoints.SAVE, payload);
  }
}

export const designationService = new DesignationService();
